import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, patch, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, ProductModel, SortOptionModel } from "@insite/client-framework/Types/ApiModels";

export interface MyPurchaseHistoryModel extends BaseModel {
    myPurchaseHistory: PurchaseHistoryModel;
}

export interface PurchaseHistoryModel {
    adminDC?: string;
    customerNumber: string;
    customerSuffix: string;
    isShopMyBranch: boolean;
    pagination: PurchaseHistoryPaginationModel;
    products: ProductModel[] | null;
    resultMessage: string;
    pageName: string;
    searchText?: string;
    fromDate?: string;
    toDate?: string;
}

export interface MyPurchaseHistoryApiParams extends ApiParameter {
    purchasedProductLines?: ProductModel[];
    productInfosByLineId?: SafeDictionary<ProductInfo>;
    pagination: PurchaseHistoryPaginationModel;
    pageName: string;
    searchText: string;
    fromDate?: string;
    toDate?: string;
    isShopMyBranch?: boolean;
    sortType?: string | null;
}

export type MyPurchaseHistoryListViewType = "List" | "Grid";

export interface PurchaseHistoryPaginationModel {
    currentPage: number;
     page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOptionModel[] | null;
    sortType: string | null;
    nextPageUri: string | null;
    prevPageUri: string | null;
}


export interface ADIProductPricingModel {
    productId: string, 
    unitOfMeasure: string, 
    qtyOrdered: number
}

const url = "/api/v2/adiglobalproducts/getMyPurchaseHistoryProduct";

export async function getMyPurchaseHistoryProduct(parameter: MyPurchaseHistoryApiParams): Promise<ServiceResult<MyPurchaseHistoryModel>> {
    try {
        const result = await patch<MyPurchaseHistoryModel>(`${url}`, parameter as any );
        return {
            successful: true,
            result: result,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}